// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { VERSION } from './version';

export const environment = {
    baseUri: 'http://localhost:3013',
    apiBaseUri: 'https://localhost:5003/api',
    portalSite: 'https://www.lez.gent',
    userKey: '',
    tenantId: '',
    production: false,
    env: '',
    version: VERSION,
    lezStartDate: '2019-09-01',
    contactInfo: {
        phoneNumber: '003292101030',
        site: 'https://www.lez.gent'
    },
    cookieyesId: ''
};

/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
